var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-white" }, [
    _c(
      "div",
      {
        staticClass:
          "capterra-review-card d-flex flex-column justify-content-between",
      },
      [
        _c("div", { staticClass: "card-top-container" }, [
          _vm._m(0),
          _c("div", { staticClass: "mb-15" }, [
            _c("p", { staticClass: "title font-outfit-semi-bold mt-0 mb-15" }, [
              _vm._v(" " + _vm._s(_vm.title) + " "),
            ]),
            _c("p", { staticClass: "description m-0 mb-3 mb-md-0" }, [
              _vm._v(" " + _vm._s(_vm.description) + " "),
            ]),
          ]),
          _c("div", { staticClass: "read-more" }, [
            _c(
              "a",
              {
                staticClass: "font-outfit-semi-bold",
                attrs: { href: _vm.link, target: "_blank" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("pages.pricing.capterraReviews.readMore")) +
                    " "
                ),
              ]
            ),
          ]),
        ]),
        _c("div", [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("div", { staticClass: "mr-3" }, [
              _c("img", {
                attrs: {
                  src: _vm.user.avatar,
                  alt: _vm.user.name,
                  width: "52",
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "d-flex flex-column justify-content-center" },
              [
                _c("span", { staticClass: "user-name font-outfit-semi-bold" }, [
                  _vm._v(_vm._s(_vm.user.name)),
                ]),
                _c("span", { staticClass: "user-title" }, [
                  _vm._v(_vm._s(_vm.user.title)),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "stars-and-logo d-flex justify-content-between align-items-center",
      },
      [
        _c("div", [
          _c("img", {
            staticClass: "d-md-none",
            attrs: {
              src: require("@/assets/img/pricing/capterra-reviews/stars-mobile.png"),
              alt: "stars",
            },
          }),
          _c("img", {
            staticClass: "stars d-none d-md-block",
            attrs: {
              src: require("@/assets/img/pricing/capterra-reviews/stars.png"),
              alt: "stars",
            },
          }),
        ]),
        _c("div", [
          _c("img", {
            staticClass: "capterra-logo",
            attrs: {
              src: require("@/assets/img/pricing/capterra-reviews/capterra-logo.png"),
              alt: "capterra-logo",
            },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }